import { Faker, en, lv } from '@faker-js/faker';

// Estonian locale currently doesn't exist in faker-js which is why we are using latvian locale instead
export const latvianFaker = new Faker({ locale: [lv, en] });
